import { Button } from './Button'

interface Props {
  onCaptureTeaming: () => void
  onArchitectureReview: () => void
}

export function TalkToUs({ onCaptureTeaming, onArchitectureReview }: Props) {
  return (
    <section id="talk" className="bg-chalk py-20 lg:py-24 scroll-mt-16">
      <div className="mx-auto max-w-6xl px-6">
        <header className="text-center mb-12 max-w-2xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-semibold text-navy tracking-tight">
            Two ways to start.
          </h2>
          <p className="mt-3 text-base text-navy/70">
            Pick the conversation that fits where you are. Both route to a CyLogic engineer
            or capture lead — same day reply within business hours.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card
            eyebrow="For capture engineers"
            title="Capture team conversation"
            body="Teaming, capability statement, sub-pricing memo, federal bid support. Bring CyCloud into your capture package and we'll move at your pace."
            cta="Start the conversation"
            onClick={onCaptureTeaming}
          />
          <Card
            eyebrow="For technical leads"
            title="Architecture review"
            body="30-minute session with a CyLogic solutions architect. Workload sizing, reference architecture, migration scoping. No commitment, no pitch deck."
            cta="Book a review"
            onClick={onArchitectureReview}
          />
        </div>
      </div>
    </section>
  )
}

function Card({
  eyebrow,
  title,
  body,
  cta,
  onClick,
}: {
  eyebrow: string
  title: string
  body: string
  cta: string
  onClick: () => void
}) {
  return (
    <article className="bg-white border border-mist rounded-card p-8 shadow-card hover:shadow-card-hover transition-shadow">
      <div className="font-data text-xs uppercase tracking-wide text-mint font-medium">
        {eyebrow}
      </div>
      <h3 className="mt-3 text-xl font-semibold text-navy">{title}</h3>
      <p className="mt-3 text-sm text-navy/70 leading-relaxed">{body}</p>
      <div className="mt-6">
        <Button onClick={onClick}>{cta} →</Button>
      </div>
    </article>
  )
}
